import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './RacingThemePartnerInquiryPanel.module.css';

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/**
 * Partner listing CTA column — benefits + inquiry / watchlist.
 */
const RacingThemePartnerInquiryPanel = props => {
  const {
    className,
    title,
    price,
    priceSuffix,
    benefits,
    primaryCta,
    secondaryCta,
    onSendInquiry,
    onWatchlist,
  } = props;

  return (
    <aside className={classNames(css.root, className)}>
      <h2 className={css.title}>{title}</h2>
      <p className={css.price}>
        {price}
        {priceSuffix ? <span className={css.priceSuffix}>{priceSuffix}</span> : null}
      </p>

      {benefits?.length ? (
        <ul className={css.benefits}>
          {benefits.map(item => (
            <li key={item} className={css.benefit}>
              <span className={css.check}>
                <CheckIcon />
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      ) : null}

      <button className={css.primaryBtn} type="button" onClick={onSendInquiry}>
        {primaryCta}
      </button>
      <button className={css.secondaryBtn} type="button" onClick={onWatchlist}>
        {secondaryCta}
      </button>
    </aside>
  );
};

RacingThemePartnerInquiryPanel.defaultProps = {
  className: null,
  priceSuffix: null,
  benefits: [],
  primaryCta: 'Send Inquiry',
  secondaryCta: 'Add to Watchlist',
  onSendInquiry: () => {},
  onWatchlist: () => {},
};

RacingThemePartnerInquiryPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  priceSuffix: PropTypes.string,
  benefits: PropTypes.arrayOf(PropTypes.string),
  primaryCta: PropTypes.string,
  secondaryCta: PropTypes.string,
  onSendInquiry: PropTypes.func,
  onWatchlist: PropTypes.func,
};

export default RacingThemePartnerInquiryPanel;
